var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('span',{staticClass:"icon-status",class:_vm.statusClass,style:(_vm.statusStyle)},[_c('i',{class:_vm.iconClass})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }